export const bulletTypes = ['check-mark', 'x-mark'] as const;
